// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip--tooltip--GZj+A","label":"Tooltip--label--E+I+f","arrow":"Tooltip--arrow--b3Ire"};